/* Film na karcie produktu startuje po najechaniu myszka (zgloszenie
   7.09.2026, wzorzec micadoni.com).

   Trzy rzeczy decyduja o tym, ze to nie obciaza listingu:
   1. `preload="none"` i adres trzymany w `data-src` - plik rusza dopiero
      przy PIERWSZYM najechaniu na dana karte, wiec kategoria z 40 kafelkami
      nie pobiera 40 filmow.
   2. Nasluch jest JEDEN, na dokumencie (`pointerover` / `pointerout`).
      Karty przeladowuja sie przy zmianie wariantu, wiec wiazanie po
      elemencie gubi sie po kazdym odswiezeniu - delegacja tego nie ma.
   3. Na dotyku i przy `prefers-reduced-motion` skrypt w ogole nie wchodzi;
      film jest tam ukryty rowniez w arkuszu, wiec nie ma migniecia. */
(function () {
  var moznaNajechac = window.matchMedia('(hover: hover)').matches;
  var mniejRuchu = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!moznaNajechac || mniejRuchu) return;

  function film(el) {
    var media = el && el.closest ? el.closest('.product-card__media') : null;
    return media ? media.querySelector('.product-card__video') : null;
  }

  function odtworz(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* zostaje zdjecie */ });
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var v = film(e.target);
    if (!v) return;
    /* wyjscie i powrot w obrebie tej samej karty nie ma nic robic */
    if (v.dataset.gra === '1') return;
    v.dataset.gra = '1';

    if (!v.getAttribute('src') && v.dataset.src) {
      /* `play()` wywolane w tym samym takcie co ustawienie zrodla ODPADA:
         przy `preload="none"` pobieranie jeszcze nie ruszylo, wiec obietnica
         wraca odrzucona i film zostawal zatrzymany na zerowej sekundzie
         (zmierzone 8.09.2026: `paused: true`, `currentTime: 0`).
         Stad `load()` i ponowna proba dopiero, gdy przegladarka ma material. */
      v.setAttribute('src', v.dataset.src);
      v.load();
      /* Dwa zdarzenia, nie jedno: `loadeddata` przychodzi wczesniej niz
         `canplay`, a przy wolnym laczu roznica to setki milisekund - czyli
         tyle, ile trwa najechanie i zjazd kursorem. */
      ['loadeddata', 'canplay'].forEach(function (nazwa) {
        v.addEventListener(nazwa, function () {
          if (v.dataset.gra === '1' && v.paused) odtworz(v);
        }, { once: true });
      });
      return;
    }

    odtworz(v);
  });

  /* Wygaszenie wlacza dopiero FAKTYCZNY start odtwarzania, nie sama proba -
     inaczej przez chwile widac czarna klatke zamiast zdjecia. */
  document.addEventListener('playing', function (e) {
    var v = e.target;
    if (v.classList && v.classList.contains('product-card__video')) v.dataset.ready = '1';
  }, true);

  document.addEventListener('pointerout', function (e) {
    var v = film(e.target);
    if (!v) return;
    /* `pointerout` leci takze przy przejsciu miedzy dziecmi karty */
    if (e.relatedTarget && film(e.relatedTarget) === v) return;
    delete v.dataset.gra;
    delete v.dataset.ready;
    v.pause();
    try { v.currentTime = 0; } catch (err) { /* zrodlo jeszcze nie gotowe */ }
  });
})();
